export { default as RenameSolidIcon } from './RenameSolidIcon';
